import React, { useRef, useEffect } from "react";
import { useGLTF, useTexture, useAnimations } from "@react-three/drei";
import { MeshBasicMaterial,MeshPhongMaterial,MeshPhysicalMaterial } from "three";
import { MeshTransmissionMaterial } from "@react-three/drei";
import { GradientTexture } from "@react-three/drei";
import { Html, Text } from "@react-three/drei";

import { useControls } from "leva";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/lib3.glb");

  const walls = useTexture('/walls2.png')
  walls.flipY= false

  // const materialProps = useControls({
  //   thickness: { value: 5, min: 0, max: 20 },
  //   roughness: { value: 0, min: 0, max: 1, step: 0.1 },
  //   clearcoat: { value: 1, min: 0, max: 1, step: 0.1 },
  //   clearcoatRoughness: { value: 0, min: 0, max: 1, step: 0.1 },
  //   transmission: { value: 1, min: 0.9, max: 1, step: 0.01 },
  //   ior: { value: 1.25, min: 1, max: 2.3, step: 0.05 },
  //   envMapIntensity: { value: 25, min: 0, max: 100, step: 1 },
  //   color: '#ffffff',
  //   attenuationTint: '#ffe79e',
  //   attenuationDistance: { value: 0, min: 0, max: 1 }
  // })


  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    // Slow down all animations
    const slowdownFactor = 0.7; // Adjust this value as needed

    for (const key in actions) {
      actions[key].setEffectiveTimeScale(slowdownFactor);
      actions[key].play();
    }
  }, [actions]);

  const handleClick = () => {
    // Redirect to www.google.com when the Text is clicked
    window.open('https://www.biblioteka-ks.org/', '_blank');
    // If you prefer using history.push, you can do:
    // history.push('https://www.google.com');
  };

  const handleClick1 = () => {
    // Redirect to www.google.com when the Text is clicked
    window.open('https://www.drinlajci.com/', '_blank');
    // If you prefer using history.push, you can do:
    // history.push('https://www.google.com');
  };
  
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Sketchup"
          castShadow
          receiveShadow
          geometry={nodes.Sketchup.geometry}
          material={materials.Material}
          position={[0.273, 3.066, -0.514]}
          >
          <meshBasicMaterial map={walls}/>
          <Text
        position={[0,-3,10]}
        rotation={[-1.6,0,0.01]}
       
        color={'#BDD4E7'}
        font="./NotoSerifJP-Regular.otf"
        onClick={handleClick} // Add the onClick event here
        style={{ cursor: 'pointer' }}
        >National Library of Kosova</Text>

        <Text
        scale={0.7}
        position={[-4.7,-3,13]}
        rotation={[-1.6,0,0.01]}
        color={'#BDD4E7'}
        font="./NotoSerifJP-Regular.otf"
        onClick={handleClick1} // Add the onClick event here
        style={{ cursor: 'pointer' }}
        >Drin Lajci</Text>

        <Text
        scale={0.7}
        position={[-3.5,-3,14]}
        rotation={[-1.6,0,0.01]}
        color={'#BDD4E7'}
        font="./NotoSerifJP-Regular.otf"
        onClick={handleClick1} // Add the onClick event here
        style={{ cursor: 'pointer' }}
        >Webdev | three.js</Text>
          </mesh>
        <group
          name="Armature001"
          position={[5.428, 4.609, -2.053]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          scale={0.747}
        >
          <skinnedMesh
            name="unamed001"
            geometry={nodes.unamed001.geometry}
            material={nodes.unamed001.material}
            skeleton={nodes.unamed001.skeleton}
          >
            <meshBasicMaterial color={'#948a7f'}/>
            </skinnedMesh>
          <primitive object={nodes.mixamorigHips} />
        </group>
        <mesh
          name="dome097"
          castShadow
          receiveShadow
          geometry={nodes.dome097.geometry}
          material={materials.domes}
          position={[0.483, 3.576, -0.539]}
          scale={0.452}
        >
            <MeshTransmissionMaterial
          backside
          backsideThickness={1}
          samples={10}
          thickness={1}
          anisotropicBlur={1}
          color={'#e0dcd7'}
          
         
          
        />
          </mesh>
        <group
          name="Armature"
          position={[-2.739, 0.002, 8.197]}
          rotation={[0, 1.571, 0]}
        >
          <skinnedMesh
            name="unamed"
            geometry={nodes.unamed.geometry}
            material={nodes.unamed.material}
            skeleton={nodes.unamed.skeleton}
          >
            <meshBasicMaterial color={'#948a7f'}/>
            </skinnedMesh>
          <primitive object={nodes.mixamorigHips_1} />
          <primitive object={nodes.Ctrl_Master} />
          <primitive object={nodes.Ctrl_ArmPole_IK_Left} />
          <primitive object={nodes.Ctrl_Hand_IK_Left} />
          <primitive object={nodes.Ctrl_ArmPole_IK_Right} />
          <primitive object={nodes.Ctrl_Hand_IK_Right} />
          <primitive object={nodes.Ctrl_Foot_IK_Left} />
          <primitive object={nodes.Ctrl_LegPole_IK_Left} />
          <primitive object={nodes.Ctrl_Foot_IK_Right} />
          <primitive object={nodes.Ctrl_LegPole_IK_Right} />
        </group>
        <mesh
          name="3dsoul_kuba"
          
          geometry={nodes["3dsoul_kuba"].geometry}
          material={nodes["3dsoul_kuba"].material}
          position={[6.156, 0.374, 6.29]}
          rotation={[0, 0.894, 0]}
          scale={0.359}
        >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>

          <mesh
          name="3dsoul_kuba"
          
          geometry={nodes["3dsoul_kuba"].geometry}
          material={nodes["3dsoul_kuba"].material}
          position={[3.156, 0.374, -6.79]}
          rotation={[0, 3, 0]}
          scale={0.359}
        >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>
        <mesh
          name="3Dsoul_kuba_006"
          
          geometry={nodes["3Dsoul_kuba_006"].geometry}
          material={nodes["3Dsoul_kuba_006"].material}
          position={[0, 0.381, 6.346]}
          scale={0.337}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>

          <mesh
          name="3Dsoul_kuba_006"
          
          geometry={nodes["3Dsoul_kuba_006"].geometry}
          material={nodes["3Dsoul_kuba_006"].material}
          position={[0, 0.381, -7.346]}
          scale={0.337}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>
        <mesh
          name="3D_soul_-_sitting_man_-_Vrata"
          
          geometry={nodes["3D_soul_-_sitting_man_-_Vrata"].geometry}
          material={nodes["3D_soul_-_sitting_man_-_Vrata"].material}
          position={[-6.319, 0.25, 6.495]}
          scale={0.379}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>
          <mesh
          name="3D_soul_-_sitting_man_-_Vrata"
          
          geometry={nodes["3D_soul_-_sitting_man_-_Vrata"].geometry}
          material={nodes["3D_soul_-_sitting_man_-_Vrata"].material}
          position={[-6.319, 0.25, -1.895]}
          rotation={[0,3.8,0]}
          scale={0.379}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>
        <mesh
          name="3Dsoul_tom"
          
          geometry={nodes["3Dsoul_tom"].geometry}
          material={nodes["3Dsoul_tom"].material}
          position={[-5.781, 0.364, 3.28]}
          rotation={[0,4,0]}
          scale={0.358}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>

          <mesh
          name="3Dsoul_tom"
          
          geometry={nodes["3Dsoul_tom"].geometry}
          material={nodes["3Dsoul_tom"].material}
          position={[6.281, 0.364, 0.28]}
          rotation={[0,1,0]}
          scale={0.358}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>
        <mesh
          name="__3Dsoul_katka_001_001"
          
          geometry={nodes.__3Dsoul_katka_001_001.geometry}
          material={nodes.__3Dsoul_katka_001_001.material}
          position={[0.892, 0.117, 6.801]}
          scale={0.342}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>

          <mesh
          name="__3Dsoul_katka_001_001"
          
          geometry={nodes.__3Dsoul_katka_001_001.geometry}
          material={nodes.__3Dsoul_katka_001_001.material}
          position={[6.892, 0.117, -5.801]}
          rotation={[0,2,0]}
          scale={0.342}
          >
          <meshBasicMaterial color={'#948a7f'}/>
          </mesh>
      </group>
    </group>
  );
}

useGLTF.preload("/lib3.glb");
